import { render } from "./RecipeMeal.vue?vue&type=template&id=69c4eed9&scoped=true"
import script from "./RecipeMeal.vue?vue&type=script&lang=js"
export * from "./RecipeMeal.vue?vue&type=script&lang=js"

import "./RecipeMeal.vue?vue&type=style&index=0&id=69c4eed9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c4eed9"]])

export default __exports__